import { RouteNamesEnum } from "@/localConstants";
import { RouteType } from "@/types";

interface RouteWithTitleType extends RouteType {
  title: string;
}

export const routes: RouteWithTitleType[] = [];
